import firebase from "firebase";
import Vue from "vue";
import App from "./App.vue";
import VueFragment from "vue-fragment";

Vue.config.productionTip = false

// Vue.use(VueFragment.Plugin);

/* import * as Sentry from "@sentry/browser";

Sentry.init(
{
	dsn: "https://318f30e66d31476b9f899e515321b103@sentry.io/1330695",
	integrations: [ new Sentry.Integrations.Vue({ Vue }) ]
}); */

firebase.initializeApp(
{
	apiKey: "AIzaSyBbWZptvBPuOZX0DdwVUJERHiAYo7CqoCA",
	authDomain: "language-16386.firebaseapp.com",
	databaseURL: "https://language-16386.firebaseio.com",
	projectId: "language-16386",
	storageBucket: "language-16386.appspot.com",
	messagingSenderId: "879846328951"
});

firebase.auth().onAuthStateChanged(() =>
{
	import("./router").then((module) =>
	{
		const router = module.default;

		const app = new Vue(
		{
			router,
			render: h => h(App)
		});

		app.$mount("#app");
	});
});
